import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { BackendApiService } from '../../../app/services/backend-api.service';
// import { ValidationService } from '../../../validation.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { from } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbar } from '@angular/material/toolbar';
import { MatFormField } from '@angular/material/form-field';


@Component({
  selector: 'app-add-group',
  templateUrl: './add-group.component.html',
  styleUrls: ['./add-group.component.scss'],
  standalone:true,
  imports:[CommonModule,MatMenuModule,MatToolbar,ReactiveFormsModule,MatFormField]
})
export class AddGroupComponent implements OnInit {
  private addApplicationUrl = BaseUrlConstantsService.ADD_APPLICATION;
  private updateApplicationUrl = BaseUrlConstantsService.UPDATE_APPLICATION;
  public clientId: any;
  public options: FormGroup;
  public visible = true;
  public selectable = true;
  public removable = true;
  public addOnBlur = true;
  public uForm: any;
  public associatedUser: string;
  public assetName: string;
  public assetList: any;
  public clientList: any;
  public siteID: any;
  public siteName: any;
  public pageName: string;
  public groupName: string;
  public groupID: any;
  public pageType: string;
  public showUpdateBtn: boolean;
  public showEditUsertxt: string;
  public breadcrumbsArray: any = [{
    page_ref: 'site-groups',
    page_title: 'site'
  }, {
    page_ref: 'client-group-list',
    page_title: 'Applications'
  }, {
    page_ref: '#',
    page_title: 'add application'
  }];
  savebtn: boolean;
  constructor(
    public service: BackendApiService,
    private activeRoute: ActivatedRoute,
    private changeService: ChangeUsersService,
    private formBuilder: FormBuilder,
    public router: Router) {
    activeRoute.queryParams.subscribe(params => {
      this.pageType = params[`pageType`];
      this.groupName = params[`groupName`];
      this.groupID = params[`groupID`];
      this.siteID = params[`siteID`];
      this.siteName = params[`siteName`];
      this.pageName = params[`pageRef`];
      if (this.pageName === 'managerAssets') {
        const myObj = {
          page_ref: 'manager-client-list',
          page_title: 'manager clients'
        };
        this.breadcrumbsArray.unshift(myObj);
      }
    });
    if (this.pageType === 'edit-group') {
      this.showUpdateBtn = true;
      this.savebtn = false;
      this.showEditUsertxt = 'Edit Application';
    } else {
      this.showUpdateBtn = false;
      this.savebtn = true;
      this.showEditUsertxt = 'Add Application';
    }
  }
 
  goToPageLink(name: string) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: 'managerAssets' === this.pageName ? 'managerAssets' : '',
        siteID: this.siteID,
        siteName: this.siteName
      }
    };
    this.router.navigate([name], navigationExtras);
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  addApplications() { }

  ngOnInit() {
    if (this.pageType === 'edit-group') {
      this.uForm = this.formBuilder.group({
        site_name: new FormControl({ value: this.siteName, disabled: true }),
        group_name: new FormControl({ value: this.groupName, disabled: false }, [Validators.required, this.noWhitespaceValidator]),
        group_description: new FormControl('')
      });
    } else {
      this.uForm = this.formBuilder.group({
        site_name: new FormControl({ value: this.siteName, disabled: true }),
        group_name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
        group_description: new FormControl('')
      });
    }
    this.clientId = localStorage.getItem('user_id');
    this.getAllAssets(this.clientId);
    this.getUsersListing(this.clientId);
  }

  getAllAssets(clientid) {
    this.service.getAllById('assets/assets.json', clientid).then(res => {
      if (res != null) {
        this.assetList = res;
      }
    });
  }

  getUsersListing(clientid) {
    const clientId = localStorage.getItem('user_id');
    if (clientId !== '') {
      this.service.getAllById('assets/clientusers.json', clientId).then(data => {
        this.clientList = data;
      });
    }
  }

  addDevice() {
    this.router.navigate(['/add-group']);
  }

  doSomething(ev: any) {

  }

  selectAssociatedUser(username: string) {
    this.associatedUser = username;
  }

  selectAssociatedAsset(assetsname: string) {
    this.assetName = assetsname;
  }


  saveSiteGroup() {
    if (this.uForm.dirty && this.uForm.valid) {
      const body = {
        user_id: localStorage.getItem('user_id'),
        site_id: this.siteID,
        name: this.uForm.value.group_name
      };
      this.changeService.loader(true);
      this.service.postData(this.addApplicationUrl, body).then(res => {
        this.changeService.loader(false);
        if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
          const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
          this.service.showError(msgErr);
        } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          this.service.showSuccess('Application registered successfully');
          this.router.navigate(['/site-groups']);
        } else {
          this.service.showError('Something went wrong.');
        }
      });
    }
  }


  saveDevice() {
    if (this.uForm.dirty && this.uForm.valid) {
      const body = {
        user_id: localStorage.getItem('user_id'),
        site_id: this.siteID,
        name: this.uForm.value.group_name
      };
      this.changeService.loader(true);
      this.service.putData(this.updateApplicationUrl + "/" + this.groupID, body).then(res => {
        this.changeService.loader(false);
        if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
          const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
          this.service.showError(msgErr);
        } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          this.service.showSuccess('Application updated successfully');
          const navigationExtras = {
            skipLocationChange: true,
            queryParams: {
              pageRef: 'managerAssets' === this.pageName ? 'managerAssets' : '',
              siteID: this.siteID,
              siteName: this.siteName
            }
          };
          this.router.navigate(['/site-groups'], navigationExtras);
        } else {
          this.service.showError('Something went wrong.');
        }
      });
    }
  }
}
